import { createMultiStyleConfigHelpers } from '@chakra-ui/react'
import { textStyleKeys } from '~/themes/textStyles'

import { settingsColorKeys } from './_colors'

const Colors = settingsColorKeys.Settings.CallCenterSettings

const CallCenterSettingsParts = [
  'customStatusContainer',
  'customStatusContent',
  'statusIndicator',
  'statusTitle',
  'statusDescription',
  'actionButtons',
] as const

const helpers = createMultiStyleConfigHelpers(CallCenterSettingsParts)

export const CallCenterSettingsStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    customStatusWrapper: {
      width: '100%',
      gap: '0.5rem',
      flexDir: 'column',
      alignItems: 'flex-start',
    },
    customStatusHeaderContainer: {
      gap: '1.75rem',
      flexDir: 'column',
    },
    customStatusHeaderContent: {
      flexDir: 'column',
      alignItems: 'flex-start',
      gap: '0.625rem',
    },
    customStatusContainer: {
      width: '100%',
      gap: '0.5rem',
      padding: '0.25rem 0.75rem',
      alignItems: 'center',
      borderRadius: '0.5rem',
      border: '1.5px solid',
      borderColor: Colors.CustomStatus.Container.Border,
      background: Colors.CustomStatus.Container.Background,
    },
    customStatusContent: {
      flexDir: 'column',
      padding: '0.25rem 0rem',
      alignItems: 'flex-start',
      flex: '1 0 0',
    },
    statusIndicator: {
      width: '1rem',
      height: '1rem',
      borderRadius: '6.25rem',
    },
    statusTitle: {
      overflow: 'hidden',
      color: Colors.CustomStatus.Title.Color,
      textOverflow: 'ellipsis',
      textStyle: textStyleKeys.Body2,
    },
    statusDescription: {
      overflow: 'hidden',
      color: Colors.CustomStatus.Description.Color,
      textOverflow: 'ellipsis',
      textStyle: textStyleKeys.Body3,
    },
    actionButtons: {
      gap: '0.25rem',
    },
  },
})
